"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferByAccountSchema = exports.TransferByPixKeySchema = void 0;
const zod_1 = require("zod");
const string_fns_1 = require("./utils/string.fns");
const makeMessage = (field) => `O ${field} fornecido para a chave Pix é inválido`;
const EmailPixKey = zod_1.z.object({
    key_type: zod_1.z.literal('email'),
    key: zod_1.z
        .string()
        .email()
        .min(1, { message: makeMessage('email') }),
});
const CpfOrCnpjPixKey = zod_1.z.object({
    key_type: zod_1.z.literal('cpf_or_cnpj'),
    key: zod_1.z
        .string()
        .min(1, { message: makeMessage('cpf/cnpj') })
        .transform(string_fns_1.removeCpfCharacters),
});
const PhonePixKey = zod_1.z.object({
    key_type: zod_1.z.literal('phone'),
    key: zod_1.z.string().regex(/\+55[0-9]{2}[0-9]{8,9}/, { message: makeMessage('celular') }),
});
const RandomPixKey = zod_1.z.object({
    key_type: zod_1.z.literal('random'),
    key: zod_1.z.string().uuid({ message: 'Chave pix é inválida' }),
});
exports.TransferByPixKeySchema = zod_1.z.object({
    type: zod_1.z.literal('pix_key'),
    key: zod_1.z.discriminatedUnion('key_type', [EmailPixKey, CpfOrCnpjPixKey, PhonePixKey, RandomPixKey]),
});
exports.TransferByAccountSchema = zod_1.z.object({
    type: zod_1.z.literal('account'),
    account_type: zod_1.z
        .enum(['checking_account', 'savings_account', 'salary_account', 'payment_account'])
        .default('checking_account'),
    bank_ispb_code: zod_1.z.string().min(1, { message: 'O código ISPB fornecido é inválido' }),
    account: zod_1.z.string().min(1, { message: 'O número da conta é inválido' }),
    account_digit: zod_1.z.string().min(1, { message: 'O dígito da conta é inválido' }).optional(),
    branch: zod_1.z.string().min(1, { message: 'O número da agência é inválido' }),
    branch_digit: zod_1.z.string().min(1, { message: 'O dígito da agência é inválido' }).optional(),
});
